import { rehydrate } from 'overmind';
import { Context } from '../index';
import { Session } from './state';

export const setSession = (context: Context, theValue: Session | null) => {
  // nested object in tree, rework this
  // state.session.sessionData.accessList = theValue?.accessList?.slice(); // TODO: spread operator getting tslib error [...accessList];
  // delete theValue?.accessList;

  // this nonsense only required because we're using the root namespace state as a class
  // const keys = Object.keys(state.session.sessionData);
  // const defaults = {};
  // keys.forEach(item => {
  //   defaults[item] = null;
  // });

  // const theUpdate = { ...defaults, ...theValue };
  rehydrate(context.state.session, {
    sessionData: theValue || null,
  });

  // console.log('setSession theUpdate: ', theUpdate);
  // console.log('setSession state.session: ', state.session);
  // console.log('setSession theValue: ', theValue);
  // console.log('setSession defaults: ', defaults);
  // console.log('setSession state.session.sessionData', state.session.sessionData);
  // const keys = Object.keys(theValue);

  // console.log('state.session: ', state.session);
  // console.log('state.session keys: ', keys);
  // keys.forEach(field => {
  //   state.session[field] = theValue[field];
  // });

  context.actions.session.saveToStorage();
};

export const logout = async (context: Context) => {
  await context.effects.api.logout();
  context.actions.session.destroy();

  window.location.href = '/v2/login';
};

export const saveToStorage = (context: Context) => {
  console.log('saving to storage: ', context);
  console.log('saving to storage context.state.session: ', context.state.session);
  console.log('saving to storage context.state.auth: ', context.state.auth);
  window.localStorage.currentUser = JSON.stringify({
    fields: Object.keys(context.state.session.sessionData),
    accessList: context.state.auth.accessList,
    ...context.state.session.sessionData,
  });
};

export const removeFromStorage = () => {
  delete window.localStorage.currentUser;
};

export const setCurrentUserFromStorage = (context: Context) => {
  const { currentUser: session } = window.localStorage;

  if (!session) return;

  // TODO: continue here, type out session properties into new model
  context.actions.session.update(JSON.parse(session));
};

// ******************************
// TODO: older functions to remove eventually
export const create = (context: Context, theValue: Session) => {
  context.actions.session.setSession(theValue);
};

export const destroy = (context: Context) => {
  context.actions.session.setSession(null);
  context.actions.session.removeFromStorage();
};

export const update = (context: Context, theValue: Session) => {
  context.actions.session.setSession(theValue);
};
// ******************************

export const getAccessListIds = (context: Context) => {
  const { accessList } = context.state.auth;
  const { sessionData } = context.state.session;

  const pubType = sessionData.allPubs ? 'publishers' : 'merchants';

  const role = sessionData.isAdmin ? pubType : sessionData.userRole;
  const list = sessionData.isAdmin ? sessionData.allAdminOrgs : accessList;

  return list.reduce((agg: any, org: any) => {
    if (org.orgId !== sessionData.orgId && org.type === role) {
      agg += `${!agg ? '' : ','}${org.orgId}`;
    }
    return agg;
  }, '');
};
